const TAP_LIFT_DURATION_MS = 120

const tapTimers = new WeakMap<HTMLElement, ReturnType<typeof setTimeout>>()

function isCoarsePointerDevice() {
  if (typeof window === 'undefined') {
    return false
  }

  return window.matchMedia('(hover: none), (pointer: coarse)').matches
}

export function playActionEffectTap(element: HTMLElement) {
  if (!isCoarsePointerDevice()) {
    return
  }

  const existingTimer = tapTimers.get(element)

  if (existingTimer) {
    clearTimeout(existingTimer)
  }

  element.classList.remove('action-effect-tap-active')
  void element.offsetWidth

  element.classList.add('action-effect-tap-active')

  const timer = window.setTimeout(() => {
    element.classList.remove('action-effect-tap-active')
    tapTimers.delete(element)
  }, TAP_LIFT_DURATION_MS)

  tapTimers.set(element, timer)
}
